/** @typedef {import('./Props').default} Props */

import { translate } from '../../../App/Internationalization';
import formatCentsForDisplay from '../../../utils/formatCentsForDisplay';
import React from 'react';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
function SubscriptionPrice(props) {
	/** @returns {JSX.Element} */
	function renderCopy() {
		if (props?.checkoutRole !== 'manager') {
			return (
				<p className="text-ms-1 mt-1 font-bold">
					{translate('subscription.plans.per_month')}
				</p>
			);
		}

		return (
			<div className="mt-1 font-bold">
				<p className="text-ms-1">
					{translate('subscription.plans.per_agent')}
				</p>
				<p className="text-ms-1 -mt-2">
					{translate('subscription.plans.per_month')}
				</p>
			</div>
		);
	}

	return (
		<div className="flex gap-1">
			<p className="font-bold text-ms-8">
				{formatCentsForDisplay(props?.price)}
			</p>

			{renderCopy()}
		</div>
	);
}

export default React.memo(SubscriptionPrice);
